(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function init() {
    document.querySelectorAll('product-info media-gallery').forEach((gallery) => {
      if (gallery.dataset.zenMobileInit === 'true') return;
      gallery.dataset.zenMobileInit = 'true';
      setupGallery(gallery);
    });
  }

  function setupGallery(gallery) {
    const slider = gallery.querySelector('slider-component .product__media-list');
    if (!slider) return;
    const items = Array.from(slider.querySelectorAll('.product__media-item'));
    if (items.length < 1) return;

    // Build footer (badge + dots) if not present
    let footer = gallery.querySelector('.zen-mobile-footer');
    let dots = gallery.querySelector('.zen-mobile-dots');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'zen-mobile-footer';

      // Badge slot — clone existing .product-badges into footer left (keep original for desktop)
      const badgeSlot = document.createElement('div');
      badgeSlot.className = 'zen-mobile-footer__badge';
      const existingBadges = gallery.querySelector('.product-badges');
      if (existingBadges) {
        badgeSlot.appendChild(existingBadges.cloneNode(true));
      }
      footer.appendChild(badgeSlot);

      // Dots container
      dots = document.createElement('div');
      dots.className = 'zen-mobile-dots';
      dots.setAttribute('role', 'tablist');
      dots.setAttribute('aria-label', 'Product image pagination');
      items.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'zen-mobile-dots__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        if (i === 0) dot.classList.add('is-active');
        dot.addEventListener('click', () => scrollToIndex(slider, items, i));
        dots.appendChild(dot);
      });
      footer.appendChild(dots);

      // Empty spacer to balance badge for true center alignment of dots
      const spacer = document.createElement('div');
      spacer.className = 'zen-mobile-footer__spacer';
      footer.appendChild(spacer);

      gallery.appendChild(footer);
    }

    // Smooth scroll behavior
    slider.style.scrollBehavior = 'smooth';

    // Update active dot on scroll
    let rafId = null;
    const onScroll = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => updateActiveDot(slider, items, dots));
    };
    slider.addEventListener('scroll', onScroll, { passive: true });

    // Update on slide change events from Dawn slider-component
    gallery.addEventListener('slideChanged', () =>
      updateActiveDot(slider, items, dots)
    );

    // Initial state
    updateActiveDot(slider, items, dots);

    // Toggle visibility based on viewport
    const applyVisibility = () => {
      dots.style.display = MOBILE_MQ.matches && items.length > 1 ? 'flex' : 'none';
    };
    applyVisibility();
    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', applyVisibility);
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(applyVisibility);
    }
  }

  function scrollToIndex(slider, items, index) {
    const target = items[index];
    if (!target) return;
    const offset = target.offsetLeft - slider.offsetLeft;
    slider.scrollTo({ left: offset, behavior: 'smooth' });
  }

  function updateActiveDot(slider, items, dots) {
    const center = slider.scrollLeft + slider.clientWidth / 2;
    let closestIdx = 0;
    let closestDist = Infinity;
    items.forEach((item, i) => {
      const itemCenter = item.offsetLeft - slider.offsetLeft + item.offsetWidth / 2;
      const dist = Math.abs(itemCenter - center);
      if (dist < closestDist) {
        closestDist = dist;
        closestIdx = i;
      }
    });
    dots.querySelectorAll('.zen-mobile-dots__dot').forEach((d, i) => {
      d.classList.toggle('is-active', i === closestIdx);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
